import { Component, OnInit } from '@angular/core';
import { TicketType, TicketTypeService } from '@smartnowx/hcms-plugin-event-manager';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sale',
  templateUrl: './sale.component.html',
  styleUrl: './sale.component.scss',
  standalone: false,
})
export class SaleComponent implements OnInit {

  public ticketTypes: TicketType[] = [];

  constructor(private ticketTypeService: TicketTypeService) { }

  ngOnInit(): void {

    this.ticketTypes = [];

    environment.DEFAULT_EVENTS.forEach(event => {
      this.ticketTypeService.getTicketTypes(event).subscribe({
        next: (ticketTypes) => {
          this.ticketTypes = this.ticketTypes.concat(ticketTypes.filter(ticketType => ticketType.active === 1).filter(ticketType => new Date(ticketType.sale_start) < new Date() && new Date(ticketType.sale_end) > new Date()).sort((a, b) => {
              return (a?.queue || 99) > (b?.queue || 99) ? 1 : -1;
          }));

          sessionStorage.setItem('ticketTypes', JSON.stringify(this.ticketTypes));
          console.log('Ticket Types for event', event, ':', this.ticketTypes);  
        },
        error: (error) => {
          console.error('Error fetching ticket types:', error);
        }
      });
    });
  }

}
